import api from '@/api/base'
import bus from '@/global/bus'
import { t } from '@/global/i18n'

const auth = {
  async requestMagicLink(email, companySlug) {
    try {
      const response = await api.post('/auth/magic/request', { email, companySlug })
      return response.data
    } catch (error) {
      console.error(t('errors.api.auth.magicLinkRequestFailed'), error)
      throw error
    }
  },

  async requestLeasingMagicLink(email) {
    try {
      const response = await api.post('/auth/magic/request', { email, type: 'leasing' })
      return response.data
    } catch (error) {
      console.error(t('errors.api.auth.magicLinkRequestFailed'), error)
      throw error
    }
  },

  async verifyMagicLink(token, challenge) {
    try {
      const response = await api.post('/auth/magic/verify', { token, challenge })
      const { accessToken, refreshToken } = response.data

      this.setTokens(accessToken, refreshToken)
      return response.data
    } catch (error) {
      console.error(t('errors.api.auth.magicLinkVerifyFailed'), error)
      throw error
    }
  },

  async verifyLeasingMagicLink(token, challenge) {
    try {
      const response = await api.post('/auth/magic/verify', { token, challenge, type: 'leasing' })
      const { accessToken, refreshToken } = response.data

      this.setTokens(accessToken, refreshToken)
      return response.data
    } catch (error) {
      console.error(t('errors.api.auth.magicLinkVerifyFailed'), error)
      throw error
    }
  },

  async requestBankId(companySlug) {
    try {
      const response = await api.post('/auth/bankid/request', { companySlug })
      return response.data
    } catch (error) {
      console.error(t('errors.api.auth.bankIdRequestFailed'), error)
      throw error
    }
  },

  async verifyBankId(orderReference, companySlug) {
    try {
      const response = await api.post('/auth/bankid/verify', { orderReference, companySlug })
      return response.data
    } catch (error) {
      console.error(t('errors.api.auth.bankIdVerifyFailed'), error)
      throw error
    }
  },

  async verifyBankIdOrganization(orderReference, companySlug) {
    try {
      const response = await api.post('/auth/bankid/verify-organization', {
        orderReference,
        companySlug,
      })
      return response.data
    } catch (error) {
      console.error(t('errors.api.auth.bankIdVerifyFailed'), error)
      throw error
    }
  },

  async requestMitId(companySlug) {
    try {
      const response = await api.post('/auth/mitid/request', { companySlug })
      return response.data
    } catch (error) {
      console.error(t('errors.api.auth.mitIdRequestFailed'), error)
      throw error
    }
  },

  async verifyMitId(orderReference, companySlug) {
    try {
      const response = await api.post('/auth/mitid/verify', { orderReference, companySlug })
      return response.data
    } catch (error) {
      console.error(t('errors.api.auth.mitIdVerifyFailed'), error)
      throw error
    }
  },

  async verifyMitIdOrganization(orderReference, companySlug) {
    try {
      const response = await api.post('/auth/mitid/verify-organization', {
        orderReference,
        companySlug,
      })
      return response.data
    } catch (error) {
      console.error(t('errors.api.auth.mitIdVerifyFailed'), error)
      throw error
    }
  },

  async verifyImpersonation(guid, secret) {
    try {
      const response = await api.post('/auth/impersonation/verify', { guid, secret })
      const { accessToken, refreshToken } = response.data

      this.setTokens(accessToken, refreshToken)
      // we'll return the companySlug to the caller
      return response.data
    } catch (error) {
      console.error(t('errors.api.auth.impersonationVerifyFailed'), error)
      throw error
    }
  },

  isAuthenticated() {
    return !!localStorage.getItem('auth_token')
  },

  getToken() {
    return localStorage.getItem('auth_token')
  },

  setTokens(token, refreshToken) {
    localStorage.setItem('auth_token', token)
    localStorage.setItem('refresh_token', refreshToken)
  },

  removeTokens() {
    localStorage.removeItem('auth_token')
    localStorage.removeItem('refresh_token')
  },
}

// Handle logout event
bus.on('auth-logout', () => {
  auth.removeTokens()
  bus.emit('user-logout')
})

export default auth
